module.exports = __webpack_public_path__ + "img/hebergement.b3f9daae.png";